const contactData = {
    location: "Fremont, CA",
    email: "austinhshih@gmail.com",
    phone: "510-737-3634",
}

export default contactData